// Per-product КБЖУ breakdown for a FatSecret-synced meal. Each product shows
// its name + serving (FatSecret's own label, e.g. "200 г" or "2 large") and a
// К/Б/Ж/У line. The meal total is rendered by the parent, not here.
import { FatSecretAttribution } from './FatSecretAttribution'

const F = 'Roboto, sans-serif'

export interface MealItem {
  name: string
  serving?: string | null
  calories?: number | null
  protein?: number | null
  fat?: number | null
  carbs?: number | null
}

function fmt(n?: number | null): string {
  if (n == null) return '0'
  // Trim trailing ".0" so 12.0 → "12" but 12.6 stays.
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 10) / 10)
}

export function MealItemsBreakdown({ items }: { items: MealItem[] }) {
  if (!items?.length) return null
  return (
    <div data-testid="meal-items-breakdown" style={{ display: 'flex', flexDirection: 'column', gap: 6, margin: '2px 0 8px' }}>
      {items.map((it, i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            paddingBottom: i < items.length - 1 ? 6 : 0,
            borderBottom: i < items.length - 1 ? '1px solid #F1F4F8' : 'none',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline' }}>
            <span style={{ fontSize: 12.5, fontWeight: 600, color: '#1C2D41', fontFamily: F, lineHeight: 1.3 }}>
              {it.name}
              {it.serving ? <span style={{ fontWeight: 400, color: '#8A94A6' }}>{` · ${it.serving}`}</span> : null}
            </span>
            <span style={{ fontSize: 12.5, fontWeight: 700, color: '#374151', fontFamily: F, whiteSpace: 'nowrap' }}>
              {fmt(it.calories)} ккал
            </span>
          </div>
          <div style={{ fontSize: 11.5, color: '#6B7280', fontFamily: F }}>
            {`Б ${fmt(it.protein)} · Ж ${fmt(it.fat)} · У ${fmt(it.carbs)}`}
          </div>
        </div>
      ))}
      {/* Данные о продуктах приходят из FatSecret — атрибуция обязательна по их политике. */}
      <FatSecretAttribution style={{ marginTop: 2 }} />
    </div>
  )
}
